import React, { useEffect, useState } from 'react';
import { Table, Tag, Space, Button, Input } from 'antd';
import { SearchOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

interface Contract {
  id: string;
  title: string;
  upload_time: string;
  risk_level: string;
  status: string;
  party_a?: string;
  party_b?: string;
  amount?: number;
}

const ContractsPage: React.FC = () => {
  const [contracts, setContracts] = useState<Contract[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchContracts();
  }, []);

  const fetchContracts = async () => {
    setLoading(true);
    try {
      const response = await api.get('/contracts');
      setContracts(response.data);
    } catch (error) {
      console.error('获取合同列表失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const getRiskTagColor = (level: string) => {
    switch (level) {
      case '高风险': return 'red';
      case '中风险': return 'orange';
      case '低风险': return 'blue';
      default: return 'default';
    }
  };

  const columns = [
    {
      title: '合同名称',
      dataIndex: 'title',
      key: 'title',
      render: (text: string) => <a>{text}</a>,
    },
    {
      title: '上传时间',
      dataIndex: 'upload_time',
      key: 'upload_time',
      render: (time: string) => new Date(time).toLocaleString(),
    },
    {
      title: '甲方',
      dataIndex: 'party_a',
      key: 'party_a',
      render: (text: string) => text || '-',
    },
    {
      title: '乙方',
      dataIndex: 'party_b',
      key: 'party_b',
      render: (text: string) => text || '-',
    },
    {
      title: '金额',
      dataIndex: 'amount',
      key: 'amount',
      render: (amount: number) => amount ? `¥${amount.toLocaleString()}` : '-',
    },
    {
      title: '风险等级',
      dataIndex: 'risk_level',
      key: 'risk_level',
      render: (level: string) => (
        <Tag color={getRiskTagColor(level)}>
          {level || '待审核'}
        </Tag>
      ),
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag color={status === '已审核' ? 'green' : 'gold'}>
          {status}
        </Tag>
      ),
    },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: Contract) => (
        <Space size="middle">
          <Button 
            type="link" 
            icon={<EyeOutlined />}
            onClick={() => navigate(`/audit/${record.id}`)}
          >
            查看
          </Button>
        </Space>
      ),
    },
  ];

  const filteredContracts = contracts.filter(contract =>
    contract.title.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div>
      <h1 style={{ marginBottom: 24 }}>合同管理</h1>
      
      <div style={{ marginBottom: 16 }}>
        <Input
          placeholder="搜索合同名称"
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          style={{ width: 300 }}
        />
      </div>

      <Table
        columns={columns}
        dataSource={filteredContracts}
        loading={loading}
        rowKey="id"
      />
    </div>
  );
};

export default ContractsPage;